/**
 * Whether the OS/browser prefers higher contrast (`prefers-contrast: more`),
 * used as the default for the high-contrast world view.
 *
 * Doesn't key off `forced-colors: active` — that's a user-chosen palette of
 * any contrast, not necessarily high contrast.
 */
const prefersHighContrast = (): boolean => window.matchMedia?.('(prefers-contrast: more)').matches ?? false;

export { prefersHighContrast };
